import { Controller } from '@hotwired/stimulus'

// Opens the add-to-library modal from a template card, prefilled with the
// card's cached Meta copy so the CS operator only genericizes and publishes.
export default class extends Controller {
  static targets = ['container', 'sourceId', 'contextField', 'title', 'body', 'buttons', 'moment']

  open(event) {
    event.preventDefault()
    const { templateId, templateTitle, templateContext, templateBody, templateButtons } = event.currentTarget.dataset

    this.sourceIdTarget.value = templateId
    this.contextFieldTarget.value = templateContext
    this.titleTarget.value = templateTitle
    this.bodyTarget.value = templateBody
    this.buttonsTarget.value = templateButtons || ''
    this.scopeMomentsTo(templateContext)

    this.containerTarget.classList.remove('hidden')
    document.body.style.overflow = 'hidden'
  }

  scopeMomentsTo(context) {
    if (!this.hasMomentTarget) return
    this.momentTarget.querySelectorAll('optgroup').forEach((group) => {
      const foreign = group.dataset.context !== context
      group.hidden = foreign
      group.disabled = foreign
    })
    const first = this.momentTarget.querySelector(`optgroup[data-context="${context}"] option`)
    if (first) this.momentTarget.value = first.value
  }

  close(event) {
    if (event) event.preventDefault()
    this.containerTarget.classList.add('hidden')
    document.body.style.overflow = 'auto'
  }

  connect() {
    this.escHandler = (e) => {
      if (e.key === 'Escape' && this.hasContainerTarget && !this.containerTarget.classList.contains('hidden')) {
        this.close()
      }
    }
    document.addEventListener('keydown', this.escHandler)
  }

  disconnect() {
    document.removeEventListener('keydown', this.escHandler)
  }
}
